export const WHITE_BOARD_LIST_REQUEST = "WHITE_BOARD_LIST_REQUEST";
export const WHITE_BOARD_LIST_SUCCESS = "WHITE_BOARD_LIST_SUCCESS";
export const WHITE_BOARD_LIST_FAILURE = "WHITE_BOARD_LIST_FAILURE";

export const RESET_STATE = "RESET_STATE";

export const WHITE_BOARD_BY_ID_REQUEST = "WHITE_BOARD_BY_ID_REQUEST";
export const WHITE_BOARD_BY_ID_SUCCESS = "WHITE_BOARD_BY_ID_SUCCESS";
export const WHITE_BOARD_BY_ID_FAILURE = "WHITE_BOARD_BY_ID_FAILURE";